import { render, staticRenderFns } from "./Economics.vue?vue&type=template&id=0333c680"
import script from "./Economics.vue?vue&type=script&lang=js"
export * from "./Economics.vue?vue&type=script&lang=js"
import style0 from "./Economics.vue?vue&type=style&index=0&id=0333c680&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports